// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"d30e7684c4--checkbox--E83MD","box":"d30e7684c4--box--TSmoe","invalid":"d30e7684c4--invalid--duKFV","disabled":"d30e7684c4--disabled--WW5p9"};